/** @jsxImportSource @emotion/react */
import styled, { Interpolation } from "@emotion/styled";
import RadioButton from "./radio-button";
import { useState } from "react";
import { Theme } from "@emotion/react";

type TRadioGroup = {
    data?: string[];
    onChange?: (value: string) => void;
    defaultValue?: string;
    styles?: Interpolation<Theme>;
    selectedItem?: string;
};

const GroupContainer = styled.div`
    display: flex;
    gap: 24px;
`;

const RadioGroup = (prop: TRadioGroup) => {
    const { data, onChange, defaultValue, styles, selectedItem } = prop;
    const [selected, setSelected] = useState<string | null>(defaultValue ? defaultValue : null);
    return (
        <GroupContainer css={styles}>
            {data?.map((item, index) => (
                <RadioButton
                    label={item}
                    key={index}
                    active={selectedItem ? selectedItem === item : selected === item}
                    onClick={() => {
                        setSelected(item);
                        onChange?.(item);
                    }}
                />
            ))}
        </GroupContainer>
    );
};

export default RadioGroup;
